import { render } from "./CommandListComponent.vue?vue&type=template&id=54f086b5&scoped=true&ts=true"
import script from "./CommandListComponent.vue?vue&type=script&lang=ts"
export * from "./CommandListComponent.vue?vue&type=script&lang=ts"

import "./CommandListComponent.vue?vue&type=style&index=0&id=54f086b5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f086b5"]])

export default __exports__